export const listTypes = {
    AD_HOC: 'AD_HOC',
    AD_HOC_CONCEPT: 'AD_HOC_CONCEPT',
    JAVA_ENUM: 'JAVA_ENUM',
    CONCEPT: 'CONCEPT',
    CODE_SYSTEM: 'CODE_SYSTEM',
    VALUE_SET: 'VALUE_SET'
};

export default { listTypes };
